import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-word-textarea-large-filter',
  templateUrl: './html/word-filter-textarea-large.html',
  styleUrls: [
    '../../../../../assets/css/main.css',
    '../../../../../assets/scss/fontawesome.scss',
    '../../../../../assets/scss/brands.scss',
    '../../../../../assets/scss/regular.scss',
    '../../../../../assets/scss/solid.scss',
    './word-filter.scss'

  ]
})

export class WordFilterTextareaLargeComponent implements OnInit {
  @Input() filter: any;
  @Output() updateQuery: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
  }

  updateQueryEvent(event) {
    // // if (!event) { return; }
    // let values = null;
    // if (event) {
    //   values = event.split(',').map(value => value.trim().toLowerCase());
    // }
    // this.updateQuery.emit({[this.filter.name]: values});
    if (!event) { return; }

    // When you insert list of words separated by new line, it will be converted to comma separated list
    if(event.value.includes('\n')) {
      event.value = event.value.replaceAll('\n', ',');
    }

    const values = event.value.split(',').map(value => value.trim().toLowerCase());

    console.log("Emitting values: ", values)
    this.updateQuery.emit({[this.filter.name]: values});
  }
}
